import type { ReactNode } from "react";

type PatternBackgroundProps = {
  /** URL of the background image/SVG (e.g. `import bg from "@/assets/background_gray.svg"`). */
  background: string;
  /** CSS `background-size`. Defaults to `cover` (single image, fills the whole area). */
  size?: string;
  /** Content centered on top of the background (e.g. a card). */
  children: ReactNode;
  className?: string;
};

/**
 * Full-bleed brand-pattern background with its children centered on top.
 * The brand SVGs don't tile seamlessly, so a single instance is used (no repeat)
 * and scaled to cover the whole area. Reused across the app for card-on-pattern
 * screens (login, password, info pages…), swapping the `background` per section.
 */
export default function PatternBackground({
  background,
  size = "cover",
  children,
  className = "",
}: PatternBackgroundProps) {
  return (
    <div
      className={`flex w-full flex-1 items-center justify-center bg-center bg-no-repeat px-4 py-10 sm:px-6 sm:py-16 ${className}`}
      style={{ backgroundImage: `url(${background})`, backgroundSize: size }}
    >
      {children}
    </div>
  );
}
